export const HELPER_TEXT_STYLES = `
    position: absolute;
    top: 100%;
    left: 0;
    line-height: 1;
`;
